/* eslint-disable no-prototype-builtins */
/* eslint-disable react-hooks/rules-of-hooks */
import { Instance, types } from "mobx-state-tree";

const Helpful = types
    .model({
      helpfulState: types.optional(types.boolean, false),
      helpfulNum: types.optional(types.string, "0")
    })
const Anonymous = types
    .model({
        nickName: types.optional(types.string, ""),
        userImage: types.optional(types.string, ""),
        isAnoymous: types.optional(types.boolean, false)
    })
export const CommentOptsStoreModel = types
  .model("CommentOptsStore")
  .props({
    helpfuls: types.map(Helpful),
    anonymous: types.map(Anonymous),
    comment: types.map(types.number),
  })
  .volatile(() => ({
    commentListeners: [] as Array<(commentId: string, newValue: number) => void>,
    helpfulListeners: [] as Array<(commentId: string, newValue: typeof Helpful) => void>,
  }))
  .actions((self: any) => ({
    changeHelpState(commentId: string, params: {}) {
      self.helpfuls.set(commentId, Helpful.create(params))
      self.helpfulListeners.forEach((listener: any) => listener(commentId, params));
    },
    onHelpfulChange(listener: (commentId: string, newValue: typeof Helpful) => void) {
      self.helpfulListeners.push(listener);
      return () => {
        const index = self.helpfulListeners.indexOf(listener);
        if (index !== -1) {
          self.helpfulListeners.splice(index, 1);
        }
      };
    },
    changeAnonymousState(commentId: string, params: {}) {
        self.anonymous.set(commentId, Anonymous.create(params))
    },
    changeCommentState(commentId: string, commentNum: number) {
        self.comment.set(commentId, commentNum)
        self.commentListeners.forEach((listener: any) => listener(commentId, commentNum));
    },
    onCommentChange(listener: (commentId: string, newValue: number) => void) {
      self.commentListeners.push(listener);
      return () => {
        const index = self.commentListeners.indexOf(listener);
        if (index !== -1) {
          self.commentListeners.splice(index, 1);
        }
      };
    }
  }));

export interface CheckoutStoreModel extends Instance<typeof CommentOptsStoreModel> {}
